import { useState } from 'react'
import { useEffect } from 'react'
import clientes from '../../api/clientes'
import * as S from './styles'

const ProfileGimba = () => {
  const [news, setNews] = useState({
    receberNovidades: false,
    receberWhatsApp: false
  })

  const onChange = async (value, field, state = news) => {
    setNews((prev) => ({
      ...prev,
      [field]: value
    }))
    fetchPatch({ ...state, [field]: value })
  }

  const fetchGet = async (set) => {
    let response = await clientes.getNews()
    response = await response.json()
    set(response)
  }

  const fetchPatch = async (body) => {
    await clientes.patchNews(body)
  }

  useEffect(() => {
    fetchGet(setNews)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <S.PerfilBox>
      <S.PerfilTitle>
        Gostaria de receber ofertas da Gimba em seu e-mail?
      </S.PerfilTitle>
      <S.PerfilFormGroup>
        <S.PerfilInputCheck
          checked={news.receberWhatsApp}
          onChange={(e) => onChange(e.target.checked, 'receberWhatsApp')}
          type="checkbox"
          name="receberWhatsApp"
          id="receberWhatsApp"
        ></S.PerfilInputCheck>
        <S.PerfilLabel htmlFor="receberWhatsApp">
          Receber comunicação via Whatsapp
        </S.PerfilLabel>
      </S.PerfilFormGroup>
      <S.PerfilFormGroup>
        <S.PerfilInputCheck
          checked={news.receberNovidades}
          onChange={(e) => onChange(e.target.checked, 'receberNovidades')}
          type="checkbox"
          name="receberNovidades"
          id="receberNovidades"
        ></S.PerfilInputCheck>
        <S.PerfilLabel htmlFor="receberNovidades">
          Receber e-mails promocionais e de parceiros.
        </S.PerfilLabel>
      </S.PerfilFormGroup>
    </S.PerfilBox>
  )
}

export default ProfileGimba
